var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7857 7.46429C11.7857 7.26339 11.5848 7.0625 11.3839 7.0625H8.4375V4.11607C8.4375 3.91518 8.23661 3.71429 8.03571 3.71429H6.96429C6.72991 3.71429 6.5625 3.91518 6.5625 4.11607V7.0625H3.61607C3.3817 7.0625 3.21429 7.26339 3.21429 7.46429V8.53571C3.21429 8.77009 3.3817 8.9375 3.61607 8.9375H6.5625V11.8839C6.5625 12.1183 6.72991 12.2857 6.96429 12.2857H8.03571C8.23661 12.2857 8.4375 12.1183 8.4375 11.8839V8.9375H11.3839C11.5848 8.9375 11.7857 8.77009 11.7857 8.53571V7.46429ZM15 2.10714C15 1.23661 14.2634 0.5 13.3929 0.5H1.60714C0.703125 0.5 0 1.23661 0 2.10714V13.8929C0 14.7969 0.703125 15.5 1.60714 15.5H13.3929C14.2634 15.5 15 14.7969 15 13.8929V2.10714ZM13.3929 13.692C13.3929 13.8259 13.2924 13.8929 13.192 13.8929H1.80804C1.67411 13.8929 1.60714 13.8259 1.60714 13.692V2.30804C1.60714 2.20759 1.67411 2.10714 1.80804 2.10714H13.192C13.2924 2.10714 13.3929 2.20759 13.3929 2.30804V13.692Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquare);
export default __webpack_public_path__ + "static/media/plus-square.f0f7bab596b4214e38bcb9e0cb5f6fd5.svg";
export { ForwardRef as ReactComponent };